import { AddCommentOutlined, CommentOutlined } from "@mui/icons-material";
import { Badge, IconButton } from "@mui/material";
import { isEmpty, size } from "lodash";
import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sidebarSetValues } from "../../../redux/actions/sidebarActions";
import { useCommentUtilsHook } from "../../../hooks/utils/useCommentUtilsHook";
import CountButton from "../../../_src_shared/buttons/CountButton";

const LoanFileCommentsBadge = ({
  showZero = false,
  // color,
  color = "primary",
  sx,
  countButton = false,
  file,
}) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  const dispatch = useDispatch();

  const { getFileAssociatedComments } = useCommentUtilsHook();

  const onPreviewClick = useCallback(
    (file) => {
      dispatch(
        sidebarSetValues({
          type: "filePreview",
          state: file,
          params: {
            openComments: true,
          },
        }),
      );
    },
    [dispatch],
  );

  const associatedComments = useMemo(() => {
    return getFileAssociatedComments(loanDrilldown?.comments, file?._id);
  }, [getFileAssociatedComments, loanDrilldown?.comments, file?._id]);

  if (size(associatedComments) === 0 && !showZero) {
    return null;
  }

  if (countButton) {
    return (
      <CountButton
        onClick={() => onPreviewClick(file)}
        icon={<CommentOutlined className="thin" />}
        count={size(associatedComments)}
        tooltip={"Comments on file"}
        sx={sx}
      />
    );
  }
  return (
    <IconButton
      size="small"
      color={color}
      onClick={() => onPreviewClick(file)}
      sx={{
        // ".MuiSvgIcon-root": {
        //   fontSize: "56px",
        // },
        ".MuiBadge-badge": {
          minWidth: "16px",
          height: "16px",
          fontSize: "10px",
          transform: "scale(1) translate(50%, -60%)",
        },
      }}
    >
      {isEmpty(associatedComments) ? (
        <AddCommentOutlined fontSize="small" className="thin" />
      ) : (
        <Badge badgeContent={size(associatedComments)} color={color}>
          <AddCommentOutlined fontSize="small" className="thin" />
        </Badge>
      )}
    </IconButton>
  );
};
export default LoanFileCommentsBadge;
